import { put, takeLatest, call, select } from "redux-saga/effects";
import { SIGN_IN_REQUEST, LOAD_REGISTERED_USER } from "../actions/sigin";
import { setTokens } from "../actions/token";
import { signInService } from "../services/signIn";
import { setUserLogin } from "../../home/actions/loggedUser";
import { getUsers } from "../../users/services/users";
import { cdnLogin } from "../../app/conf";
import { getConfigSelector } from "../../home/selectors/config";

const signInWorker = function*(action) {
    try {
        const { username, password, history } = action.payload;

        const {
            data: { access_token: accessToken, refresh_token: refreshToken, user }
        } = yield call(signInService, username, password);

        yield put(setUserLogin({ user }));

        yield put(setTokens(accessToken, refreshToken));

        // Check if user has commercial profile and redirect accordingly
        const userRole = user?.profile?.[0]?.code || user?.profile?.[0]?.name || user?.profile?.[0];
        const isCommercial = userRole?.toLowerCase() === 'commercial';
        
        if (isCommercial) {
            history.push("/activeServices");
        } else {
            history.push("/");
        }
    } catch (err) {
        window.location.href = cdnLogin;
    }
};

const loadRegisteredUserWorker = function*({ payload: { user_id, access_token, refresh_token, history } }) {
    try {
        const {
            data: { users }
        } = yield call(getUsers, { identifier: user_id }, access_token);

        yield put(setUserLogin({ user: users[0] }));

        yield put(setTokens(access_token, refresh_token));
        
        // Check if user has commercial profile and redirect accordingly
        const user = users[0];
        const userRole = user?.profile?.[0]?.code || user?.profile?.[0]?.name || user?.profile?.[0];
        const isCommercial = userRole?.toLowerCase() === 'commercial';
        
        if (isCommercial) {
            history.push("/activeServices");
        } else {
            const { currentChildRoute } = yield select(getConfigSelector);
            history.push(currentChildRoute.path);
        }
    } catch (err) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = cdnLogin;
    }
};

export default [takeLatest(SIGN_IN_REQUEST, signInWorker), takeLatest(LOAD_REGISTERED_USER, loadRegisteredUserWorker)];
